<div  class="fadein animation-duration-400 card relative">
  <no-records-found *ngIf="!internalDocs.description" [displayText]="'No Items Found'" class="grid-record-placement"/>
  <ckeditor *ngIf="internalDocs" [config]="ckEditorConfig" [data]="internalDocs.description || ''"
            [disabled]="true" [editor]="Editor"
            id="classic-editor"></ckeditor>
</div>
